var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 114 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H113.459L103.058 115.271L57.0445 128.271L10.164 115.271L0 0ZM92.4217 19.3037H21.1948L24.898 61.9296H74.1422L72.724 80.8393L56.8082 85.1728L40.8925 80.8393L39.7894 69.4147H25.6859L27.6556 91.6337L56.8082 99.6703L85.8032 91.5549L89.5852 47.9836H37.8984L36.4802 32.777H91.161L92.4217 19.3037Z",
    fill: "#F0E3CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.710b1834fa94e2285da05b8b37b7ebc6.svg";
export { ForwardRef as ReactComponent };